var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 9.9L11 0 8.8 2.1l8.4 8.4H1v3h16.2l-8.4 8.4L11 24l9.8-9.9L23 12z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiBpZD0iaWNvbi1hcnJvdyI+CiAgPHBhdGggZD0iTTIwLjggOS45TDExIDAgOC44IDIuMWw4LjQgOC40SDF2M2gxNi4ybC04LjQgOC40TDExIDI0bDkuOC05LjlMMjMgMTJ6Ii8+Cjwvc3ZnPgo=";
export { SvgMore as ReactComponent };